import { motion } from 'framer-motion';

const ClientsVendorsSection = ({ variant = 'full' }) => {
  // Placeholder logos - can be replaced with real logos later
  const clients = [
    { name: 'Tech Solutions Ltd', logo: '/logos/clients/Podar.png' },
    { name: 'Hospitality Group', logo: '/logos/clients/Jamnabai.png' },
    { name: 'Delhi Public School', logo: '/logos/clients/Kidzee.png' },
    { name: 'St. Xavier\'s College', logo: '/logos/clients/Riverdale.png' },
    { name: 'Mumbai Cricket League', logo: '/logos/clients/Universal.png' },
    { name: 'Corporate Marathon', logo: '/logos/clients/CP goenka.png' },
  ];

  const vendors = [
    { name: 'Premium Fabrics India', logo: 'logos/vendors/skumars.png' },
    { name: 'Thread & Yarn Co', logo: 'logos/vendors/suditi.png' },
    { name: 'Quality Textiles', logo: 'logos/vendors/mafatlal.png' },
    { name: 'Logistics Partner', logo: 'logos/vendors/alok.gif' },
  ];

  return (
    <div className={variant === 'compact' ? '' : 'section-spacing bg-brand-timberwolf'} data-testid="clients-vendors-section">
      <div className="container-custom">
        {/* Clients */}
        <div className="mb-16" itemScope itemType="https://schema.org/Organization">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-8"
          >
            <h2 className="text-2xl sm:text-3xl font-heading font-bold text-brand-pearl mb-2" data-testid="clients-heading">
              Our Clients
            </h2>
            <p className="text-brand-walnut">Trusted by leading organizations across India</p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6"
          >
            {clients.map((client, idx) => (
              <div
                key={idx}
                className="bg-brand-ivory rounded-sm border border-brand-pearl/10 p-4 flex items-center justify-center grayscale hover:grayscale-0 transition-all duration-300"
                data-testid={`client-logo-${idx}`}
              >
                <img
                  src={client.logo}
                  alt={`${client.name} - Rudra Apparel Client`}
                  className="w-full h-auto object-contain"
                  loading="lazy"
                  itemProp="logo"
                />
              </div>
            ))}
          </motion.div>
        </div>

        {/* Vendors */}
        <div itemScope itemType="https://schema.org/Organization">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-8"
          >
            <h2 className="text-2xl sm:text-3xl font-heading font-bold text-brand-pearl mb-2" data-testid="vendors-heading">
              Our Vendors
            </h2>
            <p className="text-brand-walnut">Partnering with quality suppliers</p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto"
          >
            {vendors.map((vendor, idx) => (
              <div
                key={idx}
                className="bg-brand-ivory rounded-sm border border-brand-pearl/10 p-4 flex items-center justify-center grayscale hover:grayscale-0 transition-all duration-300"
                data-testid={`vendor-logo-${idx}`}
              >
                <img
                  src={vendor.logo}
                  alt={`${vendor.name} - Rudra Apparel Vendor`}
                  className="w-full h-auto object-contain"
                  loading="lazy"
                  itemProp="logo"
                />
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default ClientsVendorsSection;